'use client';
import { Categories } from './categories';
import { SubCategories } from './subcategories';
import styles from './style.module.scss';
import { useTranslations } from 'next-intl';
import cx from 'classnames';
import { sortByName, getStaticMenu } from '../../_utils/index';
import { useEsiteCtx } from 'services/esite/context';

export const SiteMapCategories = ({
  dealerSeoURL,
  categoryInfo,
  helpCenterUrl,
  helpCenterOldFaqLink,
  helpCenterEnabled,
  helpCenterContactSupportUrl,
  params,
  catLegalTermsFlagValue = false
}) => {
  const t = useTranslations();
  const buyingOptions = categoryInfo?.buyingOptions;
  const categoriesAndSubCategories = categoryInfo?.categories;
  const { catalogId, langId, storeId } = useEsiteCtx();

  const allCategories = [...buyingOptions, ...categoriesAndSubCategories];
  const staticMenu = getStaticMenu({
    t,
    dealerSeoURL,
    helpCenterUrl,
    helpCenterOldFaqLink,
    catalogId,
    langId,
    storeId,
    helpCenterEnabled,
    helpCenterContactSupportUrl,
    params,
    catLegalTermsFlagValue
  });
  const sortedCategories = sortByName(allCategories);

  const fullSiteMap = [...sortedCategories, ...staticMenu];

  return (
    <div
      className={cx('my-4', styles['categoriesAndSubCategories__container'])}
    >
      {fullSiteMap.map(({ name, seoURL, subCategories }) => (
        <ul
          key={name}
          className={cx(
            'd-block mb-4 list-unstyled',
            styles['categories__container']
          )}
        >
          <Categories name={name} seoURL={seoURL} />
          <SubCategories subCategories={subCategories} />
        </ul>
      ))}
    </div>
  );
};
